import styled from 'styled-components';
import colors from 'utils/colors';

const Input = styled.input`
  ${props =>`
    padding-block: 8px;
    padding-left: 10px;
    padding-right: 38px;
    font-size: 14px;
    line-height: 20px;
    color:  ${props.color ? props.color : colors.black};
    background: #FFFFFF;
    // border: 1px solid #BBC1C8;
    border: 1px solid #DFE1E6;
    border-radius: 6px;
    width: 100%;

    &:focus {
        outline: 0;
    }

    @media only screen and (max-width: 1024px) {
      width: 40px;
      height: 40px;
      padding: 20px;
    }
  `}
`;

export default Input;